var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alvaro-validate"},[_c('AlvaroValidateHeader'),_vm._v(" "),(_vm.loading)?_c('Spinner'):(_vm.htmlFromApi)?_c('div',{staticClass:"alvaro-validate__html-container",domProps:{"innerHTML":_vm._s(_vm.htmlFromApi)}}):_c('InputToken')],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }